// extracted by mini-css-extract-plugin
export default {"wrapper":"_796d3875","header":"_3269a5f9"};